import React from 'react';

import { ButtonBase } from '@mui/material';

import clsx from 'clsx';

import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const BaseActionButton = (props: IBaseActionButtonProps) => {
  const {
    children,
    onClick,
    styles,
    isActive = false,
    disabled = false,
  } = props;

  const { classes } = useStyles(styles);

  return (
    <ButtonBase
      aria-label="edit"
      disabled={disabled}
      className={clsx(classes.iconButton, {
        [classes.iconActiveButton]: isActive,
        [classes.disabledButton]: disabled,
      })}
      onClick={onClick}>
      {children}
    </ButtonBase>
  );
};

export default BaseActionButton;
